import { all, select, takeEvery, fork, call, put } from 'redux-saga/effects'

// action
import {
	configActions,
	adminActions,
	mainActions,
	routeActions,
} from '@redux/store/index'

// lib
import { Logger } from '@utils'

// type
import type { ConfigStateType, TabType } from '@redux/types'

function* modeSaga() {
	try {
		const mode: ConfigStateType['mode'] = yield select(state => state.config.mode)
		const tabList: TabType[] =
			mode === 'admin'
				? yield select(state => state.admin.tabList)
				: yield select(state => state.main.tabList)

		yield put(configActions.SELECTED_TAB_IDX('1'))
		yield put(configActions.TAB_LIST([...tabList]))

		const navigatePath: string = mode === 'admin' ? '/admin/home' : '/main/home'

		yield put(configActions.IS_ADMIN_DRAWER_HEAD_ANIMATED(true))
		yield put(routeActions.NAVIGATE_PATH(navigatePath))
	} catch (error) {
		Logger.warn(error)
	}
}

function* tabListSaga() {
	try {
		const mode: ConfigStateType['mode'] = yield select(state => state.config.mode)
		const tabList: TabType[] = yield select(state => state.config.tabList)

		if (mode === 'admin') {
			yield put(adminActions.TAB_LIST([...tabList]))
		} else {
			yield put(mainActions.TAB_LIST([...tabList]))
		}
	} catch (error) {
		Logger.warn(error)
	}
}

function* selectedTabIdxSaga() {
	try {
		const mode: ConfigStateType['mode'] = yield select(state => state.config.mode)
		const selectedTabIdx: string = yield select(state => state.config.selectedTabIdx)

		if (mode === 'admin') {
			yield put(adminActions.SELECTED_TAB_IDX(selectedTabIdx))
		} else {
			yield put(mainActions.SELECTED_TAB_IDX(selectedTabIdx))
		}
	} catch (error) {
		Logger.warn(error)
	}
}

function* mainSaga() {
	yield takeEvery(configActions.MODE, modeSaga)
	yield takeEvery(configActions.TAB_LIST, tabListSaga)
	yield takeEvery(configActions.SELECTED_TAB_IDX, selectedTabIdxSaga)
}

export default function* rootSaga() {
	yield all([fork(mainSaga)])
}
